import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

export const bookingSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getBookingDetails: builder.query({
      query: (id) => ({
        url: `orders-detail/${id}`,
        method: "GET",
      }),
      providesTags: [tagsTypes.GET_BOOKING_ITEM_DETAILS],
    }),
    postBookingReviewRequest: builder.mutation({
      query: (id) => ({
        url: `add-review-request/${id}`,
        method: "POST",
      }),
      invalidatesTags: [tagsTypes.GET_BOOKING_ITEM_DETAILS],
    }),
  }),
});

export const {
  useGetBookingDetailsQuery,
  usePostBookingReviewRequestMutation,
} = bookingSlice;
